import React from "react";

import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { MultiButton } from "components/Button";
import { LinkButton } from "components/Form";

import { ModalTypes } from "constants/navigation";
import { colors } from "constants/theme";

import { openModalLink } from "lib/navigation";
import { formatDateString } from "lib/timeFormats";

import { getRuleBookById } from "selectors";
import { EMPTY_ARRAY, EMPTY_OBJECT } from "lib";

const InfoSpan = styled.span`
  color: ${colors.gray40};
`;

interface RuleBookSummaryProps {
  ruleBookId: string;
  openEditSettings: () => void;
  readOnly: boolean;
}

export const RuleBookSummary = ({
  ruleBookId,
  openEditSettings,
  readOnly,
}: RuleBookSummaryProps) => {
  const ruleBook = useSelector(getRuleBookById(ruleBookId)) || EMPTY_OBJECT;

  const {
    name,
    description,
    reports = [],
    sale_sub_type_ids: saleSubTypeIds = EMPTY_ARRAY,
    effective_start_date: effectiveStartDate,
    effective_end_date: effectiveEndDate,
    is_archived: isArchived,
  } = ruleBook;

  const handleOpenRuleTester = () => {
    openModalLink(
      ModalTypes.RuleTester,
      [[], ruleBookId, false],
      window.location.hash,
    );
  };

  const ruleButtons = [
    {
      title: "Test Rule Book",
      isDisabled: false,
      onClick: handleOpenRuleTester,
      default: true,
      dataTour: "testRuleBook",
    },
  ];
  return (
    <Grid container>
      <Grid item xs={8}>
        <Grid item xs={12}>
          <h2 className="leading-none">{name}</h2>
          <p>{description}</p>
        </Grid>
        <Grid container>
          <Grid item xs={4}>
            Rule Book Reports: <InfoSpan>{reports.length} selected</InfoSpan>
          </Grid>
          <Grid item xs={4}>
            Sale Sub Types:{" "}
            <InfoSpan>{saleSubTypeIds.length} selected</InfoSpan>
          </Grid>
          <Grid item xs={4}>
            Effective Start Date:{" "}
            <InfoSpan>
              {effectiveStartDate
                ? formatDateString(new Date(effectiveStartDate))
                : ""}
            </InfoSpan>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={4}>
            Effective End Date:{" "}
            <InfoSpan>
              {effectiveEndDate
                ? formatDateString(new Date(effectiveEndDate))
                : ""}
            </InfoSpan>
          </Grid>
          <Grid item xs={4}>
            Is Archived: <InfoSpan>{isArchived ? "True" : "False"}</InfoSpan>
          </Grid>
          {!readOnly && (
            <Grid item xs={4}>
              <LinkButton onClick={openEditSettings}>Edit Settings</LinkButton>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={4} container justifyContent="flex-end">
        <Grid item>
          <MultiButton buttons={ruleButtons} />
        </Grid>
      </Grid>
    </Grid>
  );
};
